import { useAppDispatch } from "@builder/store/store";
import "./style.scss";
import { closePopup } from "@builder/store/slices/popupSlice";
import OliverText from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";

interface PopupHeaderProps {
    src: string;
    title: string;
    subtext?: string | React.ReactElement;
    children?: React.ReactNode;
    customOnClose?: () => void;
    noTranslateSub?: boolean;
    noTranslateTitle?: boolean;
}

const PopupHeader: React.FC<PopupHeaderProps> = ({
    src,
    title,
    subtext,
    children,
    customOnClose,
    noTranslateSub,
    noTranslateTitle
}: PopupHeaderProps) => {
    const dispatch = useAppDispatch();
    const handleClosePopup = () => {
        dispatch(closePopup());
    };
    const { t } = useTranslation();

    return (
        <div className="popup-header">
            <div className="img-container">
                <img src={src} alt="" />
            </div>
            <div className="title-col">
                <OliverText text={noTranslateTitle ? title : t("popup.popupHeader." + title)} size="l" weight="medium-heavy" />
                {typeof subtext === "string" ? (
                    <OliverText
                        text={
                            noTranslateSub
                                ? subtext
                                : t(
                                      title === "Edit Conditions" || title === "Conditions"
                                          ? "builderElements." + subtext
                                          : "popup.popupHeader." + subtext
                                  )
                        }
                        size="s"
                        color="base-grey"
                    />
                ) : (
                    subtext
                )}
            </div>
            {children}
            {children && <div className="divider"></div>}
            <button onClick={customOnClose ? customOnClose : handleClosePopup}>
                <img src="/x-icon-dark.svg" alt="" />
            </button>
        </div>
    );
};

export default PopupHeader;
